import { createAuthClient } from './create-auth-client';

export * from './types';

export const AuthClient = await createAuthClient()
